import { SupportedHeaderPhotoLayoutSchema } from '@apps/guest/websiteHeader';

type Event = {
  photo?: { id: string; url: string } | null | undefined;
  eventDesign?:
    | {
        activeWebsiteHeaderPresentationLayout?:
          | {
              dataJSON?: SupportedHeaderPhotoLayoutSchema;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export const getBestEventPhoto = <T extends Event>(event: T): { id: string | undefined; url: string | undefined } => {
  return {
    id: event.photo?.id || (event.eventDesign?.activeWebsiteHeaderPresentationLayout?.dataJSON as SupportedHeaderPhotoLayoutSchema)?.photos?.[0]?.id,
    url: event.photo?.url || (event.eventDesign?.activeWebsiteHeaderPresentationLayout?.dataJSON as SupportedHeaderPhotoLayoutSchema)?.photos?.[0]?.url
  };
};
